// Baut einen cookie-freien Navigations-Link.
// iPhone/iPad/Mac -> Apple Karten, sonst Google Maps. Öffnet die native App bzw. den Browser.
export function mapsUrl(address) {
  const q = encodeURIComponent(address);
  const isApple =
    typeof navigator !== "undefined" &&
    /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
  return isApple
    ? `https://maps.apple.com/?daddr=${q}`
    : `https://www.google.com/maps/dir/?api=1&destination=${q}`;
}
